import dayjs from 'dayjs'
import * as _ from 'lodash'
import { isShowHolidayFlag } from '~/scriptData/common/flag/showHolidayFlag'
import { PRODUCT_LIST_TYPES } from '~/scriptData/common/product/defineListType'
import { getApiBaseUrl } from '~/utils'

// 인자: 전시소재번호 → return component명
export const getExhMtrlTyCd = (cd, exhCnrId) => {
  switch (cd) {
    case '01':
      return 'banner'
    case '02':
      return 'product'
    case '03':
      return 'texts'
    case '04':
      return 'movies'
    case '05':
      return 'buttons'
    case '06':
      return 'categoryProduct'
    case '07':
      return 'html'
    case '08':
      return 'link'
    case '09':
      return 'bundleProducts'
    case '10':
      return 'newProducts'
    case '11':
      return 'contents'
    case '12':
      return 'curation'
    case '13':
      return 'productReview'
    case '14':
      return 'htmlProduct'
    case '16':
      return 'EventStatic'
    case '17':
      return 'timer'
    case '18':
      return 'newShorts'
    case '19':
      return 'brandCard'
    case '20':
      return 'attendance'
    default:
      return ''
  }
}

export const setExhMtrlApi = (cd) => {
  switch (cd) {
    case 'banner':
      return '/ds/exh/selBanr'
    case 'product':
      return '/ds/exh/selProduct'
    case 'texts':
      return '/ds/exh/selText'
    case 'movies':
      return '/ds/exh/selMovie'
    case 'buttons':
      return '/ds/exh/selButton'
    case 'categoryProduct':
      return '/ds/exh/selCategory'
    case 'html':
      return '/ds/exh/selHtml'
    case 'link':
      return '/ds/exh/selLink'
    case 'bundleProducts':
      return '/ds/exh/selBundle'
    case 'newProducts':
      return '/ds/exh/selNewProduct'
    case 'contents':
      // return '/ug/ugm/selMainHofCtenList' // 컨텐츠형: 수정 필요 - 레디스에서 사용할 명칭 아직 모름
      return '/ds/exh/selContent' // 컨텐츠형: 수정 필요 - 레디스에서 사용할 명칭 아직 모름
    case 'exbt':
      return '/ds/exh/selExbt'
    case 'etcExbt':
      return '/ds/exh/selExbt'
    case 'productReview':
      return '/ds/exh/selReview'
    case 'htmlProduct':
      return '/ds/exh/selHtmlProduct'
    case 'timer':
      return '/ds/exh/selTimer'
    case 'brandCard':
      return '/ds/exh/selBrandCard'
    case 'attendance':
      return '/ds/exh/selAtt'
    case 'newProductShort':
      return '/ds/exh/selNewProductShort'
    case 'newShorts':
      return '/ds/exh/selNewProductShort'
    default:
      return ''
  }
}

/**
 * 상품 전시유형코드별 전시유형 class명 조회
 * @param {String} exhType 상품 전시 유형 공통코드
 * @returns Object
 *  minSize - 상품 노출 최소 수량
 *  maxSize - 상품 노출 최대 수량
 *  pageSize - 페이징할 상품 단위
 *  class - style class명
 *  showRndBtn - 전체보기 버튼 노출 여부
 *  showNewPageBtn - 새로보기 버튼 노출 여부
 *  showMorePdBtn - 펼쳐보기 버튼 노출 여부
 *  showPkupOnlyFlag - 픽업전용플래그 노출 여부
 *  showAppOnlyFlag - 앱전용플래그 노출 여부
 *  전시 상품 노출 정책 정리
 *  https://asungdaiso.atlassian.net/l/cd/AoNWCuqL
 */

export const getProdExhType = (exhType) => {
  const getDefineListType = PRODUCT_LIST_TYPES[`EXH_${exhType}`]
  switch (exhType) {
    case '01': // 리스트형
      return { minSize: 4, maxSize: 20, pageSize: 10, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: false, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '02': // 리스트_판매알림형
      return { minSize: 4, maxSize: 4, pageSize: 4, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '03': // 1단형
      return { minSize: 1, maxSize: 20, pageSize: 1, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: false, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '04': // 2단형
      return { minSize: 2, maxSize: 20, pageSize: 2, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: false, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '05': // 가로 스와이프형
      return { minSize: 6, maxSize: 24, pageSize: 6, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '06': // 가로 스와이프형 소형 (기본형) - 소형 전시유형 공통화를 위해 추가
    case '14': // 가로 스와이프형 소형 (랭킹형)
      return { minSize: 6, maxSize: 24, pageSize: 6, listType: getDefineListType, showEmblem: true, showFlag: false, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '17': // 가로 스와이프형 소형 - 연관상품형
      return { minSize: 6, maxSize: 48, pageSize: 6, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '07': // 상품 6개 조합형 (기본형)
    case '16': // 상품 6개 조합형 (AI추천)
      return { minSize: 6, maxSize: 30, pageSize: 6, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '08': // 랭킹_리스트형
      return { minSize: 6, maxSize: 24, pageSize: 12, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: false, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '09': // 랭킹_스와이프형
      return { minSize: 6, maxSize: 24, pageSize: 12, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: false, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '10': // 상품 리뷰형
      return { minSize: 5, maxSize: 20, pageSize: 5, listType: getDefineListType, showEmblem: false, showFlag: false, showRndBtn: true, showPkupOnlyFlag: false, showAppOnlyFlag: false }
    case '12': // 기획전 목록형
      return { minSize: 3, maxSize: 18, pageSize: 1, listType: getDefineListType, showEmblem: false, showFlag: false, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '13': // 2행 가로스와이프 상품형 (dev-5910)
      return { minSize: 6, maxSize: 24, pageSize: 6, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case '15': // 세로 긴 가로스와이프형
      return { minSize: 6, maxSize: 24, pageSize: 6, listType: getDefineListType, showEmblem: true, showFlag: true, showRndBtn: true, showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case 'new': // 신상품형
      return { minSize: 0, maxSize: 200, pageSize: null, class: [], showEmblem: false, showFlag: true, showRndBtn: false, showNewPageBtn: false, showMorePdBtn: false, showPkupOnlyFlag: false, showAppOnlyFlag: false }
    case 'productMain' : // 상품 모듈에서 사용
      return { showPkupOnlyFlag: true, showAppOnlyFlag: true }
    case 'order' : // 주문 모듈에서 사용
      return { showPkupOnlyFlag: true, showAppOnlyFlag: true }
    default:
      return { minSize: 0, pageSize: 4, listType: 'card1' }
  }
}

/**
 *  전시 상품 유형별 리스트 타입 지정
 * @returns listType
 * @param {String} exhType 전시유형코드
 */
export function getProdListType (exhType) {
  const listType = getProdExhType(exhType).listType
  if (_.isEmpty(listType)) {
    return
  }
  return listType
}

/**
* @description 카테고리 타입별 상품검색 그룹핑 조건 및 인덱스
* 10 : 연령대
* 20 : 가격대
* 30 : 평점
* 40 : 대카테고리
* 60 : 소카테고리(GoodsBestSale 용)
*/
export const groupResult = {
  10: { index: 9, queryNm: 'tOrdr' },
  20: { index: 8, queryNm: 'pdPrcRange' },
  30: { index: 7, queryNm: 'revwStsc' },
  40: { index: 1, queryNm: 'largeExhCtgrNo' },
  60: { index: 0, queryNm: 'smallExhCtgrNo' },
}

/**
 * @description 카테고리 타입별 상품검색 그룹핑 조건 (totalSerarch2 용)
 * 10 : 연령대
 * 20 : 가격대
 * 30 : 평점
 * 40 : 대카테고리
 * 60 : 소카테고리(GoodsBestSale 용)_
 */
export const filterGroup = {
//  10: { filterNm: 'age' },
//  20: { filterNm: 'prc' },
//  30: { filterNm: 'review' },
//  40: { filterNm: 'lctgr' },
  60: { filterNm: 'smlCtgr' }
}

/**
 * 추천셋 기본 파라미터 설정
 * @param {Object} exhData 구좌 데이터 Object
 * @param {Object} mtrlData 소재 데이터 Object
 * @returns 소재별 솔루션 url, 구좌 개인화여부
 */
export function setDefaultParams (exhData, mtrlData) {
  const params = {}
  // params.id = 'C206' // 추천셋 코너ID - 변경시 수정 필요
  params.exhCmptmtInfo = {}
  params.searchApi = {} // 검색 솔루션 전용
  params.recmApi = {} // 추천 솔루션 전용
  if (exhData) {
    params.exhCmptmtInfo.exhCmptmtId = exhData.exhCmptmtId // 구좌 ID
    // const hdcpy1 = exhData.hdcpy1 && exhData.hdcpy1 !== '_대카' ? exhData.hdcpy1 : '' // 구좌 메인타이틀1
    const hdcpy1 = exhData.hdcpy1 ? exhData.hdcpy1 : ''// 구좌 메인타이틀1
    const hdcpy2 = exhData.hdcpy2 ? exhData.hdcpy2 : ''// 구좌 메인타이틀2
    params.exhCmptmtInfo.hdcpy = hdcpy1 + ' ' + hdcpy2
    params.exhCmptmtInfo.lginYn = exhData.lginYn // 구좌 개인화 여부
  }
  if (mtrlData) {
    params.exhCmptmtInfo.exhMtrlRgMthdCd = mtrlData.exhMtrlRgMthdCd // 전시 소재 등록 유형(수기등록, 검색 솔루션, 추천 솔루션)
    params.exhCmptmtInfo.insdYn = mtrlData.insdYn || '' // api 구분(Y : 내부 api(수동, 추천), N : 외부 api(검색))
    if (mtrlData.soltnInrkApiNm !== '') {
      const url = (mtrlData.insdYn === 'Y' ? getApiBaseUrl() : process.env.API_SSN_BASE_URL) + _.unescape(mtrlData.soltnInrkApiNm)
      const searchParam = Object.fromEntries(new URL(url).searchParams)
      params.exhCmptmtInfo.url = url.split('?')[0]
      // 검색 솔루션(searchApi) 등록 url 쿼리 기본정보 추가
      if (mtrlData.exhMtrlRgMthdCd === '20') {
        params.searchApi = searchParam
      }
    }
  }
  return params
}

/**
 * 코너의 구좌 조회
 * @param {id, $api} 코너 ID
 * @returns 구좌 List
 */
export const getAccntList = (id, $api) => {
  const params = {
    exhCnrId: id
  }

  const accountList = $api.post('/ds/exh/selExh', params).then((res) => {
    if (res.data.success) {
      return res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
    }
  })

  return accountList
}

/**
 * 각 구좌의 소재 조회
 * @param {accountList, $api} 구좌 List
 * @returns 소재 List
 */
export async function getMtrlsList (accountList, $api) {
  const promiseList = accountList.map(async (e) => {
    try {
      // 각 구좌 내 소재들을 병렬로 API 호출
      const mtrlPromises = e.mtrls.map((obj) => {
        // return: 소재별 component명
        const typeCd = getExhMtrlTyCd(obj.exhMtrlTyCd)
        // return: 소재별 api
        const url = setExhMtrlApi(typeCd)

        if (!url) { return }

        let params = {
          exhCmptmtId: e.exhCmptmtId,
          exhMtrlNo: obj.exhMtrlNo
        }

        // 상품 소재: mo(20), pc(10) 구분 필요
        if (typeCd === 'product') {
          params = {
            ...params,
            deviceTypeCd: 10
          }
        }

        return $api.post(url, params).then((res) => {
          if (res.data.success) {
            return res.data.data
          }
          return null
        }).catch(() => null)
      })

      // 모든 소재 API를 병렬로 실행
      const resultList = await Promise.all(mtrlPromises)
      return resultList
    } catch (e) {
      console.log('e', e)
      return null
    }
  })

  const mtrlsList = await Promise.all(promiseList)
  return mtrlsList
}

/**
 * 팝업 로컬 스토리지 만료정보 조회
 * @param {*} key 팝업ID
 * @returns
 *  만료일 > 오늘 현재 : true
 *  그외 : false
 */
export function getPopLocalStorage (key) {
  const getStorage = localStorage.getItem('popup')
  // 24시간이 아닌 날짜 기준으로 변경 DEV-3920, DEV-3588
  const today = dayjs().format('YYYYMMDD')
  if (getStorage && JSON.parse(getStorage)[key]) {
    const storage = JSON.parse(getStorage)
    const expireTime = JSON.parse(getStorage)[key]
    // 만료일 도달한 팝업 쿠키 삭제
    if (expireTime && (expireTime <= today || today.length < expireTime.toString().length)) {
      delete storage[key]
      localStorage.setItem('popup', JSON.stringify(storage))

      return false
    }
    return (expireTime && expireTime > today) || false
  } else {
    return false
  }
}
/**
 * 광고 팝업 세션 스토리지 정보
 * @param {*} key 팝업 키
 * @returns 세션 스토리지 저장여부
 */
export function getPopSessionStorage (key) {
  return !!sessionStorage.getItem(`closeAd-${key}`)
}

// 전시영역 휴일배송 플래그 세팅
const setHolidayDeliveryFlag = (path, store, api) => {
  if (isShowHolidayFlag(path)) {
    fetchHolidayDeliveryInfo(store, api)
  }
}
// 전시영역 휴일배송 플래그 정보 store에 commit
const fetchHolidayDeliveryInfo = (store, $api) => {
  $api.get('/ds/holiday/deliveryInfo').then((res) => {
    if (res.data.success) {
      store.commit('ds/setHolidayDeliveryInfo', res.data.data)
    }
  })
}

/**
 * 코너ID로 전시영역 코너정보 단건조회
 * @returns 전시영역 단건 코너정보
 */
const cnrInfo = async ($api, cnrId) => {
  let info = {
    exhCnrId: '',
    exhCnrNm: '',
    exhYn: '',
  }
  await $api.get('/ds/cnr/info', { params: { exhCnrId: cnrId } }).then((res) => {
    console.log(res.data)
    info = { isValidData: res.data.success, ...res.data.data }
  })
  return info
}

/**
 * 전시 영역에서 중복된 정렬 순서를 가진 항목들을 랜덤으로 섞습니다.
 *
 * @param {Object[]} mtrlsList - 소재 상세 리스트 (객체 배열)
 * @returns {Object[]} 랜덤으로 섞인 배열
 */

function getArrangedList (mtrlsList) {
  const list = []

  mtrlsList.forEach((item) => {
    const index = list.findIndex(e => e.sortOrdr === item.sortOrdr)
    if (index !== -1) {
      list[index].duplicatedList.push(item)
    } else {
      list.push({ sortOrdr: item.sortOrdr, duplicatedList: [item] })
    }
  })

  return list.flatMap((item) => {
    const shuffled = _.shuffle([...item.duplicatedList])
    return shuffled.map(dup => ({
      sortOrdr: item.sortOrdr,
      ...dup
    }))
  })
}

/**
 * 전시 영역에서 중복된 정렬 순서를 가진 상품형 소재 섞기
 * 전략상품 + 일반 상품 + 품절상품
 * 상품형, HTML상품형, 카테고리상품형에서 사용
 * @param {Object[]} mtrlsList - 소재 상세 리스트 (객체 배열)
 * @returns {Object[]} 전략상품 + 랜덤으로 섞인 일반 상품 + 품절상품
 */

function getArrangedProductList (mtrlsList) {
  if (!Array.isArray(mtrlsList)) {
    return mtrlsList
  }
  const strgyItems = mtrlsList?.filter(e => e.strgyPdYn === 'Y')
  const soldOutItems = mtrlsList?.filter(e => e.soldOutYn === 'Y' && e.strgyPdYn !== 'Y')
  const availableItems = mtrlsList?.filter(e => e.strgyPdYn !== 'Y' && e.soldOutYn !== 'Y')

  return _.uniqBy([...strgyItems, ...getArrangedList(availableItems), ...soldOutItems], 'pdNo')
}

export {
  setHolidayDeliveryFlag,
  fetchHolidayDeliveryInfo,
  cnrInfo,
  getArrangedList,
  getArrangedProductList
}
